export class GameVars {

    public static reactClass: any;
    public static paymentDone: any;
    public static startDate: Date;

    public static gameData: GameDataCandy;
    public static gameAnalytics: any;
    public static scaleY: number;
    public static currentScene: Phaser.Scene;
    public static intitialised: boolean;
    public static paused: boolean;
    public static speedFactor: number;
    public static gameOver: boolean;
    public static forcedCombo: string;
    public static score: number;
    public static isLevelUp: number;
    public static candyEngine: Candy.Engine;
    public static id: string;
    public static seed: number;
    public static firstSeed: number;
    public static cols: number;
    public static rows: number;
    public static levelingUp: boolean;
    public static iPRNG: number;
    public static numOrbs: number;
    public static orbsMoving: boolean;
    public static playerData: any;
    public static gameText: any;

    public static tc: number;
    public static kc: number;

    // public static battleOrbData : any[][] = JSON.parse(GameVars.getGameConfig());
    public static battleOrbData: any[][];

    public static isBattleWin: boolean

    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static getGameConfig(): string {
        let id = Math.floor(Math.random() * 10000);
        let arr = [];
        for (let i = 0; i < 6; i++) {
            let arrr = [];
            for (let j = 0; j < 6; j++) {
                let color = Math.ceil(Math.random() * 4);
                let obj = { color: color, id: id, mutated: false, prevPos: { c: i, r: j }, removed: false, type: 0 }
                arrr.push(obj);
                id++;
            }
            arr.push(arrr);
        }

        // removing duplicates in columns
        for (let i = 0; i < arr.length; i++) {
            const cols = arr[i];
            for (let j = 0; j < cols.length; j++) {
                const color = cols[j].color;
                if (j > 0) {
                    if (cols[j].color == cols[j - 1].color) {
                        let prevColor = cols[j].color;
                        let newColor = Math.ceil(Math.random() * 4);
                        while (newColor == prevColor) {
                            newColor = Math.ceil(Math.random() * 4);
                        }
                        cols[j].color = newColor;
                    }
                }
            }
        }

        // removing duplicates in rows
        for (let i = 0; i < 6; i++) {
            for (let j = 0; j < 6; j++) {
                if (j > 1) {
                    let topColor, bottomColor;
                    let curCandyColor = arr[j][i].color;
                    let prevCandyColor = arr[j - 1][i].color;
                    let prePrevCandyColor = arr[j - 2][i].color;
                    if (i > 0 && i < 5) {
                        topColor = arr[j][i - 1].color;
                        bottomColor = arr[j][i + 1].color;
                    }
                    if (curCandyColor == prevCandyColor && curCandyColor == prePrevCandyColor) {
                        let newColor = Math.ceil(Math.random() * 4);
                        while (newColor == curCandyColor || newColor == topColor || newColor == bottomColor) {
                            newColor = Math.ceil(Math.random() * 4);
                        }
                        arr[j][i].color = newColor;
                    }
                }
            }
        }

        return JSON.stringify(arr);
    }
}

